
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class HsnTaxMasterGrid extends Serenity.EntityGrid<HsnTaxMasterRow, any> {
        protected getColumnsKey() { return 'OMS.HsnTaxMaster'; }
        protected getDialogType() { return HsnTaxMasterDialog; }
        protected getIdProperty() { return HsnTaxMasterRow.idProperty; }
        protected getInsertPermission() { return HsnTaxMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return HsnTaxMasterRow.localTextPrefix; }
        protected getService() { return HsnTaxMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}